<script setup lang="ts">
import PlanificLogo from "@assets/logo/planific-bright.svg"
</script>

<template>
  <!-- Logging out lives in the header only: a second button here read as if
       the client could be disconnected twice (PL-70) -->
  <div class="bg-pblue flex w-full justify-center p-2">
    <div class="mx-auto flex flex-col items-center gap-3">
      <div class="flex items-center">
        <img :src="PlanificLogo" alt="Planific">
        <div class="ms-3 text-white">
          <div class="mt-2 text-3xl/5 font-medium">Planific.<span class="text-xl/5">ro</span></div>
          <div class="text-xs/4">orice, la modul simplu</div>
        </div>
      </div>
    </div>
  </div>
</template>
